import * as React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCheckmarkActiveIcon = function SvgCheckmarkActiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "zig-icon"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79289 0.792893C8.18342 0.402369 8.81658 0.402369 9.20711 0.792893C9.56759 1.15338 9.59532 1.72061 9.2903 2.1129L9.20711 2.20711L4.20711 7.20711C3.84662 7.56759 3.27939 7.59532 2.8871 7.2903L2.79289 7.20711L0.792893 5.20711C0.402369 4.81658 0.402369 4.18342 0.792893 3.79289C1.15338 3.43241 1.72061 3.40468 2.1129 3.7097L2.20711 3.79289L3.5 5.085L7.79289 0.792893Z",
    fill: props.color
  }));
};

export { SvgCheckmarkActiveIcon as ReactComponent };
